<template>
  <FusionPublicPage></FusionPublicPage>
</template>
